const LINKS = {
  guide: 'https://www.szlachetnapaczka.pl/poradnik-darczyncy/',
  regulations: 'https://www.wiosna.org.pl/regulamin-serwisu/',
  privacyPolicy: 'https://www.wiosna.org.pl/polityka-prywatnosci/',
  szpPaymentForm: 'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=button-bottom',
  szpPaymentFormUnavailableFamily:
    'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=modal-unavailable-family',
  szpPaymentFormChosenFamily:
    'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=modal-chosen-family',
  szpPaymentFormList: 'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=button-list',
  szpPaymentFormMain: 'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=main-button',
  szpPaymentFormBoxTop:
    'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=button-province',
  szpPaymentFormModalZero:
    'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=modal-zero',
  szpPaymentFormInactiveProvince:
    'https://www.szlachetnapaczka.pl/wplacam/?action=wplata&place=modal-no-family',
  szpHomePage: 'https://www.szlachetnapaczka.pl/',
  apHomePage: 'https://akademiaprzyszlosci.org.pl/',
  apOnThanksPage: 'https://akademiaprzyszlosci.org.pl/prezent-na-cale-zycie',
  apPageOnSzp: 'https://www.szlachetnapaczka.pl/akademia-przyszlosci',
  apMainPageBox:
    'https://www.szlachetnapaczka.pl/akademia-przyszlosci/?action=indeks&place=button-bottom',
  szpOnePercent:
    'https://www.szlachetnapaczka.pl/jedenprocent/?action=jedenprocent&place=main-button',
  aboutSzp: 'https://www.szlachetnapaczka.pl/o-paczce/'
}

const FOOTER_ICONS = [
  { name: '$fb', href: 'https://www.facebook.com/szlachetna.paczka/' },
  { name: '$instagram', href: 'https://www.instagram.com/szlachetnapaczka/' },
  { name: '$youtube', href: 'https://www.youtube.com/channel/UCvGAB68zmhmXWGUo-nhmbZg' },
  { name: '$linkedin', href: 'https://pl.linkedin.com/company/szlachetna-paczka' },
  { name: '$tiktok', href: 'https://www.tiktok.com/@szlachetnapaczka' }
]

export { FOOTER_ICONS, LINKS }
